(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["plekanmodules"] = factory();
	else
		root["plekanmodules"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 64);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var uuid = __webpack_require__(45);

/* harmony default export */ __webpack_exports__["a"] = ({
  debug: true,
  state: {
    languages: [],
    currentLanguge: '',
    translateLanguage: '',
    moduleList: [],
    rows: [],

    translateMode: false,
    vm: null,

    editorStart: null,
    selo: null,
    editorElement: null,
    editorElementDynamic: null,
    editorElementStable: null
  },
  init: function init(type, data) {
    this.state[type] = data;
  },
  addRow: function addRow(r, i) {
    var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r));
    tmp.index = uuid.v1();

    if (isNaN(i)) {
      this.state.rows.push(tmp);
    } else {
      this.state.rows.splice(i, 0, tmp);
    }

    this.state.vm.$plekanEvent.onAdd(tmp);
  },
  updateRows: function updateRows(index, row) {
    var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.rows));
    tmp[index] = row;
    this.state.rows = tmp;
    this.state.vm.$plekanEvent.onUpdate(tmp, index);
  },
  deleteRow: function deleteRow(r, i) {
    var tmp = this.state.rows.splice(i, 1);
    this.state.vm.$plekanEvent.onDelete(tmp, i);
  },
  dublicateRow: function dublicateRow(r, i) {
    this.addRow(r, i);
    this.state.vm.$plekanEvent.onDuplicate(r, i);
  },
  sortRows: function sortRows(_new, old) {
    this.state.rows.move(old, _new);
    this.state.vm.$plekanEvent.onSort(_new, old);
  },
  changeTranslateMode: function changeTranslateMode() {
    this.state.translateMode = !this.state.translateMode;
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helper__ = __webpack_require__(5);






var DEFAULT_CONTENT = '<div contenteditable="true">DEFAULT</div>';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['store', 'index', 'displayLanguage'],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT,
      _updatable: null
    };
  },

  computed: {
    _languages: function _languages() {
      return this.store.state.languages;
    },
    me: function me() {
      return this.store.state.rows[this.index];
    },
    _content: function _content() {
      var c = this.me.contents[this.displayLanguage].html;
      return c || this.DEFAULT_CONTENT;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var ct = this.$el.querySelectorAll('[contenteditable]');
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ct).map(function (e) {
      ct[e].contentEditable = true;
      return true;
    });

    this._languages.map(function (l) {
      try {
        var html = _this.me.contents[l].html;
        _this.me.contents[l].html = html || _this.DEFAULT_CONTENT;
      } catch (e) {
        var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.me));

        tmp.contents[l] = {};
        tmp.contents[l].html = _this.DEFAULT_CONTENT;
        tmp.contents[l].fields = {};

        _this.store.updateRows(_this.index, tmp);
      }
      return true;
    });

    this._setEditable();

    document.addEventListener('mousedown', function (e) {
      var target = e.target;
      var isModalElement = !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helper__["a" /* hasParent */])(target, 'plekan-modal');

      _this._updatable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helper__["b" /* childOf */])(target, _this.store.state.editorElement) || isModalElement || target.className === 'editor';
    });

    document.addEventListener('mouseup', function () {
      _this._updatable = null;
    });

    document.addEventListener('domupdated', function () {
      _this._updateHTML();
    }, false);
  },
  updated: function updated() {
    this._setEditable();
  },

  methods: {
    _setEditable: function _setEditable() {
      var _this2 = this;

      this.$el.onfocus = function () {
        _this2.store.state.editorElementStable.classList.add('active');
      };

      this.$el.onblur = function () {
        if (!_this2._updatable) {
          _this2._updateHTML();
          _this2.store.state.editorElementDynamic.classList.remove('active');
          _this2.store.state.editorElementStable.classList.remove('active');
        }
      };
    },
    _updateHTML: function _updateHTML() {
      this.me.contents[this.displayLanguage].html = this.$el.innerHTML.trim();
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(23), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return childOf; });
/* unused harmony export getParents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setActiveEditorButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exec; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store__ = __webpack_require__(1);




Element.prototype.remove = function () {
  this.parentElement.removeChild(this);
};

NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
  for (var i = this.length - 1; i >= 0; i--) {
    if (this[i] && this[i].parentElement) {
      this[i].parentElement.removeChild(this[i]);
    }
  }
};

Array.prototype.move = function (oldIndex, newIndex) {
  if (newIndex >= this.length) {
    var k = newIndex - this.length;
    while (k-- + 1) {
      this.push(undefined);
    }
  }
  this.splice(newIndex, 0, this.splice(oldIndex, 1)[0]);
  return this;
};

var childOf = function childOf(c, p) {
  try {
    while ((c = c.parentNode) && c !== p) {}
    return !!c;
  } catch (err) {
    return false;
  }
};


var getParents = function getParents(el) {
  var a = el;
  var parents = [];

  while (a) {
    parents.unshift(a);
    a = a.parentNode;
  }
  return parents;
};

var hasParent = function hasParent(el, parentClassName) {
  var parents = getParents(el);
  var hasParents = null;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(parents).map(function (e, i) {
    var cl = parents[i];
    if (cl.className) {
      if (cl.className.indexOf(parentClassName) !== -1) {
        hasParents = cl;
      }
    }
    return true;
  });

  return hasParents;
};

var setActiveEditorButtons = function setActiveEditorButtons() {
  var el = __WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].state.selo.selection.focusNode.parentNode;
  var parents = getParents(el);

  var allAnchorTag = document.getElementsByTagName('a');

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(allAnchorTag).map(function (index) {
    allAnchorTag[index].classList.remove('active');
    return true;
  });

  parents.map(function (e) {
    var sc = document.querySelector('a[data-tagname="' + e.tagName + '"]');
    if (sc) {
      sc.classList.add('active');
    }
    return true;
  });
};

var exec = function exec(cmd) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  __WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].state.selo.restoreSelection(__WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].state.sel);
  document.execCommand(cmd, false, val);
  setActiveEditorButtons();
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(22), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(17)
  , defined = __webpack_require__(11);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(9)
  , core      = __webpack_require__(3)
  , ctx       = __webpack_require__(28)
  , hide      = __webpack_require__(32)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(27);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(35)
  , enumBugKeys = __webpack_require__(30);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(11);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(3)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44);
module.exports = __webpack_require__(3).Object.keys;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(13)
  , toLength  = __webpack_require__(41)
  , toIndex   = __webpack_require__(40);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(24);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10)
  , document = __webpack_require__(9).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(34)
  , createDesc = __webpack_require__(37);
module.exports = __webpack_require__(8) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(6)(function(){
  return Object.defineProperty(__webpack_require__(29)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(25)
  , IE8_DOM_DEFINE = __webpack_require__(33)
  , toPrimitive    = __webpack_require__(42)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(31)
  , toIObject    = __webpack_require__(13)
  , arrayIndexOf = __webpack_require__(26)(false)
  , IE_PROTO     = __webpack_require__(38)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(16)
  , core    = __webpack_require__(3)
  , fails   = __webpack_require__(6);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(39)('keys')
  , uid    = __webpack_require__(43);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(12)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19)
  , $keys    = __webpack_require__(18);

__webpack_require__(36)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(46);
var v4 = __webpack_require__(47);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var rng = __webpack_require__(15);
var bytesToUuid = __webpack_require__(14);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(15);
var bytesToUuid = __webpack_require__(14);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(109),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(107),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(106),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(103),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plekanmodule1__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plekanmodule1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plekanmodule1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plekanmodule2__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plekanmodule2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__plekanmodule2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plekanmodule3__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plekanmodule3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__plekanmodule3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plekanmodule4__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plekanmodule4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__plekanmodule4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plekanmodule5__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plekanmodule5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__plekanmodule5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plekanmodule6__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plekanmodule6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__plekanmodule6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plekanmodule7__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plekanmodule7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__plekanmodule7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plekanmodule8__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plekanmodule8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__plekanmodule8__);









var modules = [{
  name: 'plekanmodule1',
  group: 'text',
  thumbnail: 'plekanmodule1.png',
  context: __WEBPACK_IMPORTED_MODULE_0__plekanmodule1___default.a
}, {
  name: 'plekanmodule2',
  group: 'text',
  thumbnail: 'plekanmodule2.png',
  context: __WEBPACK_IMPORTED_MODULE_1__plekanmodule2___default.a
}, {
  name: 'plekanmodule3',
  group: 'text',
  thumbnail: 'plekanmodule3.png',
  context: __WEBPACK_IMPORTED_MODULE_2__plekanmodule3___default.a
}, {
  name: 'plekanmodule4',
  group: 'text',
  thumbnail: 'plekanmodule4.png',
  context: __WEBPACK_IMPORTED_MODULE_3__plekanmodule4___default.a
}, {
  name: 'plekanmodule5',
  group: 'text',
  thumbnail: 'plekanmodule5.png',
  context: __WEBPACK_IMPORTED_MODULE_4__plekanmodule5___default.a
}, {
  name: 'plekanmodule6',
  group: 'text',
  thumbnail: 'plekanmodule6.png',
  context: __WEBPACK_IMPORTED_MODULE_5__plekanmodule6___default.a
}, {
  name: 'plekanmodule7',
  group: 'text',
  thumbnail: 'plekanmodule7.png',
  context: __WEBPACK_IMPORTED_MODULE_6__plekanmodule7___default.a
}, {
  name: 'plekanmodule8',
  group: 'text',
  thumbnail: 'plekanmodule8.png',
  context: __WEBPACK_IMPORTED_MODULE_7__plekanmodule8___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = '<section class="plekan-module-1">\n      <div class="plekan-xs-12 plekan-sm-12 plekan-md-12 plekan-lg-12">\n        <div class="p-text-center">\n          <h2>I <a href="">LOVE</a> <small>plekan</small></h2>\n          <hr>\n        </div>\n        <h1 class="p-text-center">Did you like it?</h1>\n      </div>\n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = '<section class="plekan-module-2">\n      <div class="plekan-xs-12 plekan-sm-6 plekan-md-6 plekan-lg-6">\n        \n        <h4>Sunset</h4>\n        <p>\n        The spinning Earth lit by the Sun as seen from far above the North Pole. All along the terminator, the rays from the sun hit Earth horizontally, neglecting any atmospheric effects and Earth\'s orbital motion.\n        Sunset is distinct from twilight, which has three phases, the first being civil twilight, which begins once the Sun has disappeared below the horizon, and continues[....]</p>\n      </div>\n      <div class="plekan-xs-12 plekan-sm-6 plekan-md-6 plekan-lg-6">\n        <img src="https://photos.smugmug.com/Landscape/Sunrise-Sunset/i-P6c3cjn/0/M/IMG_6426-Pano-M.jpg" alt="">\n      </div>\n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = ' <section class="plekan-module-3">\n      <div class="plekan-xs-12 plekan-sm-12 plekan-md-4 plekan-lg-4">\n        <img src="http://img2.rnkr-static.com/node_img/1589/31779858/C100/eilidh-mccormick-people-in-film-photo-1.jpg" alt="">\n        <div class="desc">\n          <h4>\xD6zge </h4>\n          <p>Lorem ipsum dolor sit amet, consectetur.</p>\n          <div class="social">\n            <a href="">facebook</a>\n            <a href="">twitter</a>\n            <a href="">github</a>\n          </div>\n        </div>\n      </div>\n      <div class="plekan-xs-12 plekan-sm-12 plekan-md-4 plekan-lg-4">\n        <img src="http://img1.rnkr-static.com/user_node_img/66/1313341/C100/john-qualen-people-in-tv-photo-u1.jpg" alt="">\n          <div class="desc">\n          <h4>Abdullah </h4>\n          <p>Lorem ipsum dolor sit amet, consectetur.</p>\n          <div class="social">\n            <a href="">facebook</a>\n            <a href="">twitter</a>\n            <a href="">github</a>\n          </div>\n        </div>\n      </div>\n      <div class="plekan-xs-12 plekan-sm-12 plekan-md-4 plekan-lg-4">\n        <img src="http://celtic-heroes.com/forum/images/avatars/gallery/Stock/DefaultAva.jpg" alt="">\n          <div class="desc">\n          <h4>Deniz </h4>\n          <p>Lorem ipsum dolor sit amet, consectetur.</p>\n          <div class="social">\n            <a href="">facebook</a>\n            <a href="">twitter</a>\n            <a href="">github</a>\n          </div>\n        </div>\n      </div>\n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = '<section class="plekan-module-4">\n        <img src="http://blog.globalknowledge.com/wp-content/uploads/2015/09/SAP-Universe54051886Blog.jpg" alt="">\n        <div class="p-text-center">\n          <h4>Universe</h4>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam, reprehenderit.</p>\n        </div>\n        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur, distinctio repellat ab dolorum ex excepturi illo praesentium repellendus, numquam cupiditate obcaecati dolore necessitatibus vero nemo blanditiis autem dolor consequatur est! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea totam nobis, enim laboriosam id beatae reru msa Lorem </p>\n      </section>\n';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = '<section class="plekan-module-5">\n      <h1>Lorem ipsum dolor sit amet, consectetur.</h1>\n      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, distinctio aspernatur ab atque voluptatibus quo hic pariatur, similique aliquid laboriosam quam eius quae amet? Ipsa cumque sapiente in, pariatur dolorem.</p>\n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = '   <section class="plekan-module-6">\n      <div class="plekan-xs-4 plekan-sm-4 plekan-md-4 plekan-lg-4">\n        <img src="http://static.boredpanda.com/blog/wp-content/uploads/2016/04/beautiful-fluffy-cat-british-longhair-thumb.jpg" alt="">   \n      </div>\n      <div class="plekan-xs-8 plekan-sm-8 plekan-md-8 plekan-lg-8">\n      <h4>Lorem ipsum dolor sit.</h4>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illum provident, voluptatem, odit sunt eos error aspernatur. Quo dolorem cumque quis aut fugiat tempora, alias! Accusantium voluptatibus nemo corrupti suscipit tempore.</p>\n          <hr>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolor libero id, quaerat eaque consectetur quod ducimus temporibus quidem odit adipisci facere sed, quo autem eum deserunt! Consequatur debitis vitae cupiditate! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Tempore laborum qui fuga doloribus culpa reprehenderit sint expedita dicta est minima laboriosam enim nisi sed quibusdam cupiditate, quod velit, ullam modi.</p>\n      </div>  \n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = ' <section class="plekan-module-7">\n       <table class="table">\n          <thead>\n            <tr>\n              <th>Firstname</th>\n              <th>Lastname</th>\n              <th>Email</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr>\n              <td>John</td>\n              <td>Doe</td>\n              <td>john@example.com</td>\n            </tr>\n            <tr>\n              <td>Mary</td>\n              <td>Moe</td>\n              <td>mary@example.com</td>\n            </tr>\n            <tr>\n              <td>July</td>\n              <td>Dooley</td>\n              <td>july@example.com</td>\n            </tr>\n          </tbody>\n        </table>\n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_mixin__ = __webpack_require__(2);




var DEFAULT_CONTENT = '<section class="plekan-module-8">\n      <img src="http://www.w3schools.com/css/trolltunga.jpg" alt="">\n      <h2>Lorem ipsum dolor sit.</h2>\n      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique natus nemo ratione, labore impedit facere eaque incidunt in praesentium quaerat ea excepturi, dolor ullam quisquam quae ex quidem tenetur a.</p>\n    </section>';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_src_core_mixin__["a" /* default */]],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT
    };
  }
});

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// plekanmodules.js